export enum HoloTrakMapTypes {
    satellite = 'satellite',
    light = 'light',
    dark = 'dark',
}
